module.exports = __webpack_public_path__ + "static/media/Melissa_Diaz.cfceb417.webp";